import DataApi from "./DataApi";

class AssignmentRuleApi extends DataApi {
  constructor() {
    super("assignmentrule");
  }

  /**
   * Fetch all assignment rules
   * @param {string} objectName - Optional: filter by object name
   * @param {boolean} activeOnly - Only fetch active rules
   */
  async fetchAll(objectName = null, activeOnly = true) {
    const params = new URLSearchParams();
    if (objectName) params.append('objectName', objectName);
    params.append('activeOnly', activeOnly);
    return await this.get(`?${params.toString()}`);
  }

  /**
   * Fetch assignment rules for a specific object
   * @param {string} objectName - The object name
   * @param {boolean} activeOnly - Only fetch active rules
   */
  async fetchByObject(objectName, activeOnly = true) {
    return await this.get(`/object/${objectName}?activeOnly=${activeOnly}`);
  }

  /**
   * Fetch a single assignment rule by ID
   * @param {string} id - Rule UUID
   */
  async fetchById(id) {
    return await this.get(`/${id}`);
  }

  /**
   * Create a new assignment rule
   * @param {Object} ruleData - Rule data
   */
  async createRule(ruleData) {
    console.log("Creating assignment rule:", ruleData);
    return await this.post("", ruleData);
  }

  /**
   * Update an existing assignment rule
   * @param {string} id - Rule UUID
   * @param {Object} updateData - Updated rule data
   */
  async updateRule(id, updateData) {
    console.log("Updating assignment rule:", id, updateData);
    return await this.put(`/${id}`, updateData);
  }

  /**
   * Delete an assignment rule
   * @param {string} id - Rule UUID
   */
  async deleteRule(id) {
    return await this.delete(id);
  }

  /**
   * Toggle assignment rule active status
   * @param {string} id - Rule UUID
   */
  async toggleStatus(id) {
    return await this.post(`/${id}/toggle`);
  }

  /**
   * Evaluate a record against assignment rules
   * @param {string} objectName - Object name
   * @param {Object} recordData - Record data
   */
  async evaluate(objectName, recordData) {
    return await this.post("/evaluate", { object_name: objectName, record_data: recordData });
  }
}

export default AssignmentRuleApi;
